import { render, staticRenderFns } from "./FullscreenImagePopUp.vue?vue&type=template&id=332f3f0d&scoped=true&"
import script from "./FullscreenImagePopUp.vue?vue&type=script&lang=js&"
export * from "./FullscreenImagePopUp.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenImagePopUp.vue?vue&type=style&index=0&id=332f3f0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332f3f0d",
  null
  
)

export default component.exports